import React from 'react';
import { ReactComponent as BagIcon } from '../../../assets/images/icon-bag.svg';
import { ReactComponent as DeliveryIcon } from '../../../assets/images/icon-bicycle.svg';
import { ReactComponent as DininIcon } from '../../../assets/images/icon-din_in.svg';
import makeStyles from '@material-ui/styles/makeStyles';
import { toLocalDate } from '../../../utils/TimeConversion';
import useFormatCurrency from '../../../localisation/useCurrency';
import { useTranslation } from 'react-i18next';
export interface ICustomerOrderItem {
    created_on: string;
    currency_iso_code: string;
    currency_symbol: string;
    hash_id: string;
    id: string;
    order_status: string;
    order_total: number;
    order_type: string;
}

const useStyles = makeStyles({
    root: {
        display: 'flex',
        borderBottom: '1px solid #E8EAF4',
        width: '100%',
        justifyContent: 'space-between',
        padding: '0.5rem',
        boxSizing: 'border-box',
    },
    leftColumn: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    rightColumn: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignContent: 'end',
    },
    orderId: {
        fontSize: '1.0625rem',
        lineHeight: '1.4375rem',
        fontWeight: 600,
        color: '#212121',
    },
    date: {
        fontSize: '1rem',
        fontWeight: 'normal',
        color: '#757575',
        lineHeight: '1.375rem',
        marginBottom: '0.9375rem',
    },
    orderType: {
        textTransform: 'uppercase',
        fontSize: '0.9375rem',
        lineHeight: '1.25rem',
        fontWeight: 600,
        color: '#212121',
        display: 'flex',
        alignItems: 'center',
        '& svg': {
            marginRight: '0.625rem',
        },
        '& span': {
            lineHeight: 0,
        },
    },
    orderValue: {
        fontSize: '1.0625rem',
        color: '#212121',
        fontWeight: 600,
        textAlign: 'right',
        lineHeight: '1.4375rem',
    },
    orderStatus: {
        backgroundColor: '#EEF0F6',
        borderRadius: '3.5rem',
        textTransform: 'uppercase',
        fontSize: '0.9375rem',
        padding: '0.3125rem 0.625rem',
        lineHeight: '1.25rem',
        color: '#424242',
    },
});
interface ICustomerOrder extends ICustomerOrderItem {
    onSelectItem: (id: string) => void;
}
const CustomerOrderItem = (props: ICustomerOrder) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { formatCurrency } = useFormatCurrency();
    function renderOrderType() {
        switch (props.order_type.toUpperCase()) {
            case 'COLLECTION':
                return (
                    <>
                        <BagIcon /> <span>{t('customers.modal.COLLECTION')}</span>
                    </>
                );
            case 'COLLECTION_POINT_PICKUP':
                return (
                    <>
                        <BagIcon /> <span>{t('customers.modal.PICKUP_NOW')}</span>
                    </>
                );
            case 'HOME_DELIVERY':
                return (
                    <>
                        <DeliveryIcon /> <span>{t('customers.modal.DELIVERY')}</span>
                    </>
                );
            default:
                return (
                    <>
                        <DininIcon /> <span>{t('customers.modal.DINE_IN')}</span>
                    </>
                );
        }
    }
    return (
        <div
            className={classes.root}
            data-component-name={`ORDER_DETAILS`}
            onClick={(e) => {
                e.stopPropagation();
                props.onSelectItem(props.id);
            }}
        >
            <div className={classes.leftColumn}>
                <div className={classes.orderId} data-component-name={props.id}>
                    {props.hash_id}
                </div>
                <div className={classes.date}>{toLocalDate(props.created_on)}</div>
                {props.order_type && <div className={classes.orderType}>{renderOrderType()}</div>}
            </div>
            <div className={classes.rightColumn}>
                <div className={classes.orderValue}>{formatCurrency(props.order_total)}</div>
                <div className={classes.orderStatus}>{t(`orderTypes.${props.order_status.toLowerCase()}`)}</div>
            </div>
        </div>
    );
};

export default CustomerOrderItem;
